import { useMutation, useQueryClient } from '@tanstack/react-query';
import { endpoints, ID } from '@rossum/api-client';
import { EnginePatchPayload } from '@rossum/api-client/engines';
import { api } from '../../../lib/apiClient';
import { engineKeys, mutationKey, queueInfoKeys } from '../keys';
import { useToastMessage } from './useToastMessage';

export const patchEngineKey = (id: ID) =>
  mutationKey(['patch_engine', id] as const);

export const usePatchEngine = (id: ID) => {
  const queryClient = useQueryClient();
  const { showToastMessage } = useToastMessage();

  return useMutation({
    mutationKey: patchEngineKey(id),
    mutationFn: (payload: EnginePatchPayload) =>
      api.request(endpoints.engines.patch(id, payload)),
    onSuccess: () => {
      showToastMessage('engineUpdated');
      queryClient.invalidateQueries({ queryKey: engineKeys.detail(id) });
      queryClient.invalidateQueries({ queryKey: queueInfoKeys.stats(`${id}`) });
    },
  });
};
